var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "supplier-manage bj" },
    [
      _c("div", { staticClass: "title" }, [
        _c(
          "div",
          { staticClass: "form jn-form-style" },
          [
            _c(
              "div",
              { staticClass: "form-item btn-wrap" },
              [
                _c("el-button", {
                  staticClass: "refresh",
                  staticStyle: { "margin-left": "5px" },
                  attrs: { type: "primary", icon: "el-icon-refresh" },
                  on: { click: _vm.onHandleRefresh },
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.onHandleCreate },
                  },
                  [_vm._v("新 增")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "选择集配中心", clearable: "" },
                    model: {
                      value: _vm.formData.logistic_business_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "logistic_business_id", $$v)
                      },
                      expression: "formData.logistic_business_id",
                    },
                  },
                  _vm._l(_vm.logisticsList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入业务员名称", clearable: "" },
                  model: {
                    value: _vm.formData.buyer_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "buyer_name", $$v)
                    },
                    expression: "formData.buyer_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入所属小组", clearable: "" },
                  model: {
                    value: _vm.formData.team_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "team_name", $$v)
                    },
                    expression: "formData.team_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入采购电话", clearable: "" },
                  model: {
                    value: _vm.formData.buyer_mobile,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "buyer_mobile", $$v)
                    },
                    expression: "formData.buyer_mobile",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "", placeholder: "请选择状态" },
                    model: {
                      value: _vm.formData.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "state", $$v)
                      },
                      expression: "formData.state",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "全部状态", value: "" },
                    }),
                    _c("el-option", { attrs: { label: "启用", value: "1" } }),
                    _c("el-option", { attrs: { label: "禁用", value: "2" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入供应商名称", clearable: "" },
                  model: {
                    value: _vm.formData.supplier_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "supplier_name", $$v)
                    },
                    expression: "formData.supplier_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入供应商电话", clearable: "" },
                  model: {
                    value: _vm.formData.supplier_mobile,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "supplier_mobile", $$v)
                    },
                    expression: "formData.supplier_mobile",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.onHandleSearch },
              },
              [_vm._v("查询")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onHandleExport } },
              [_vm._v("导 出")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "80px",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "buyer_name", align: "center", label: "业务员" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.buyer_name)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplier_name",
                  align: "center",
                  label: "发品供应商",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.supplier_name)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "on_sale_count",
                  align: "center",
                  label: "在售商品数量",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.on_sale_count)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "off_sale_count",
                  align: "center",
                  label: "下架商品数量",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.off_sale_count)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_limit_slot",
                  align: "center",
                  label: "是否限制坑位",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: scope.row.is_limit_slot
                              ? "success-text"
                              : "danger-text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.is_limit_slot ? "是" : "否") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "slot_count", align: "center", label: "坑位数" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.slot_count)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "can_add_stock",
                  align: "center",
                  label: "加库存",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: scope.row.can_add_stock
                              ? "success-text"
                              : "danger-text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.can_add_stock ? "✓" : "✗") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "can_reduce_stock",
                  align: "center",
                  label: "减库存",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: scope.row.can_reduce_stock
                              ? "success-text"
                              : "danger-text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.can_reduce_stock ? "✓" : "✗") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "can_off_goods",
                  align: "center",
                  label: "下架商品",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: scope.row.can_off_goods
                              ? "success-text"
                              : "danger-text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.can_off_goods ? "✓" : "✗") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "can_create_goods",
                  align: "center",
                  label: "新建商品",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: scope.row.can_create_goods
                              ? "success-text"
                              : "danger-text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.can_create_goods ? "✓" : "✗") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "can_edit_goods",
                  align: "center",
                  label: "编辑商品",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: scope.row.can_edit_goods
                              ? "success-text"
                              : "danger-text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.can_edit_goods ? "✓" : "✗") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "can_change_image",
                  align: "center",
                  label: "换图",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: scope.row.can_change_image
                              ? "success-text"
                              : "danger-text",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.can_change_image ? "✓" : "✗") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm.editDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog supplier-dialog",
              attrs: {
                title: _vm.dialogTitle,
                visible: _vm.editDialogVisible,
                width: "50%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.editDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contents" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "editForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.editForm,
                        rules: _vm.editRules,
                        "label-width": "auto",
                      },
                    },
                    [
                      _c("el-form-item", { attrs: { label: "供应商" } }, [
                        _c("div", [_vm._v(_vm._s(_vm.editForm.supplier_name))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "采购" } }, [
                        _c("div", [_vm._v(_vm._s(_vm.editForm.buyer_name))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "在售商品" } }, [
                        _c("div", [_vm._v(_vm._s(_vm.editForm.on_sale_count))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "下架商品" } }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.editForm.off_sale_count)),
                        ]),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "限制坑位", prop: "is_limit_slot" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "mr30",
                              model: {
                                value: _vm.editForm.is_limit_slot,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "is_limit_slot", $$v)
                                },
                                expression: "editForm.is_limit_slot",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.is_limit_slot_allow_change,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "is_limit_slot_allow_change",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.is_limit_slot_allow_change",
                              },
                            },
                            [_vm._v("允许采购更改")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.is_limit_slot_apply_all,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "is_limit_slot_apply_all",
                                    $$v
                                  )
                                },
                                expression: "editForm.is_limit_slot_apply_all",
                              },
                            },
                            [_vm._v("应用于该采购全部供应商")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "坑位数", prop: "slot_count" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "30%" },
                            attrs: { min: 0, max: 9999, controls: false },
                            model: {
                              value: _vm.editForm.slot_count,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "slot_count", $$v)
                              },
                              expression: "editForm.slot_count",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "加库存" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "mr30",
                              model: {
                                value: _vm.editForm.can_add_stock,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "can_add_stock", $$v)
                                },
                                expression: "editForm.can_add_stock",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("允许"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不允许"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_add_stock_allow_change,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_add_stock_allow_change",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_add_stock_allow_change",
                              },
                            },
                            [_vm._v("允许采购更改")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_add_stock_apply_all,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_add_stock_apply_all",
                                    $$v
                                  )
                                },
                                expression: "editForm.can_add_stock_apply_all",
                              },
                            },
                            [_vm._v("应用于该采购全部供应商")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "减库存" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "mr30",
                              model: {
                                value: _vm.editForm.can_reduce_stock,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_reduce_stock",
                                    $$v
                                  )
                                },
                                expression: "editForm.can_reduce_stock",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("允许"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不允许"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.editForm.can_reduce_stock_allow_change,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_reduce_stock_allow_change",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_reduce_stock_allow_change",
                              },
                            },
                            [_vm._v("允许采购更改")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_reduce_stock_apply_all,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_reduce_stock_apply_all",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_reduce_stock_apply_all",
                              },
                            },
                            [_vm._v("应用于该采购全部供应商")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "下架商品" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "mr30",
                              model: {
                                value: _vm.editForm.can_off_goods,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "can_off_goods", $$v)
                                },
                                expression: "editForm.can_off_goods",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("允许"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不允许"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_off_goods_allow_change,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_off_goods_allow_change",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_off_goods_allow_change",
                              },
                            },
                            [_vm._v("允许采购更改")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_off_goods_apply_all,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_off_goods_apply_all",
                                    $$v
                                  )
                                },
                                expression: "editForm.can_off_goods_apply_all",
                              },
                            },
                            [_vm._v("应用于该采购全部供应商")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "新建商品" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "mr30",
                              model: {
                                value: _vm.editForm.can_create_goods,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_create_goods",
                                    $$v
                                  )
                                },
                                expression: "editForm.can_create_goods",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("允许"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不允许"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.editForm.can_create_goods_allow_change,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_create_goods_allow_change",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_create_goods_allow_change",
                              },
                            },
                            [_vm._v("允许采购更改")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_create_goods_apply_all,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_create_goods_apply_all",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_create_goods_apply_all",
                              },
                            },
                            [_vm._v("应用于该采购全部供应商")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "mb30", attrs: { label: "编辑商品" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "mr30",
                              model: {
                                value: _vm.editForm.can_edit_goods,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "can_edit_goods", $$v)
                                },
                                expression: "editForm.can_edit_goods",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("允许"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不允许"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_edit_goods_allow_change,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_edit_goods_allow_change",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_edit_goods_allow_change",
                              },
                            },
                            [_vm._v("允许采购更改")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_edit_goods_apply_all,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_edit_goods_apply_all",
                                    $$v
                                  )
                                },
                                expression: "editForm.can_edit_goods_apply_all",
                              },
                            },
                            [_vm._v("应用于该采购全部供应商")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "换图" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "mr30",
                              model: {
                                value: _vm.editForm.can_change_image,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_change_image",
                                    $$v
                                  )
                                },
                                expression: "editForm.can_change_image",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("允许"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不允许"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.editForm.can_change_image_allow_change,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_change_image_allow_change",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_change_image_allow_change",
                              },
                            },
                            [_vm._v("允许采购更改")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editForm.can_change_image_apply_all,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "can_change_image_apply_all",
                                    $$v
                                  )
                                },
                                expression:
                                  "editForm.can_change_image_apply_all",
                              },
                            },
                            [_vm._v("应用于该采购全部供应商")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.editDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onHandleSubmit },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }